import React, { useState } from "react";
import { PageHero, Section } from "../components/PageShell";
import { downloadBrochurePdf } from "../BrochurePdf";
import { Download, ArrowRight, Mail } from "lucide-react";
import { CONTACT_EMAILS } from "../data/site";

const Advisory = () => {
    const [busy, setBusy] = useState(false);

    const handle = async () => {
        if (busy) return;
        setBusy(true);
        try {
            await downloadBrochurePdf();
        } finally {
            setBusy(false);
        }
    };

    return (
        <>
            <PageHero
                eyebrow="Aviation Cargo Advisory & Corporate Recovery Services"
                title="Strategic Reassessment & Operational Transformation"
                lead="Advisory practice — download the brochure below for the full overview of services, methodology and engagement structure."
            >
                <div className="mt-12 flex flex-wrap gap-4">
                    <button
                        onClick={handle}
                        disabled={busy}
                        className="ns-btn-primary"
                        data-testid="advisory-download-pdf"
                    >
                        <Download size={16} />
                        {busy ? "Preparing PDF…" : "Download Brochure (PDF)"}
                    </button>
                    <a
                        href={`mailto:${CONTACT_EMAILS[0]}`}
                        className="ns-btn-ghost"
                    >
                        <Mail size={16} /> Contact the practice <ArrowRight size={14} />
                    </a>
                </div>
            </PageHero>

            <Section>
                <div className="grid lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-4">
                        <div
                            className="font-body text-[11px] uppercase tracking-[0.22em] mb-3"
                            style={{ color: "var(--ns-muted)" }}
                        >
                            Engagement Lead
                        </div>
                        <h2
                            className="font-display text-3xl lg:text-4xl font-bold tracking-tight"
                            style={{ color: "var(--ns-ink)" }}
                        >
                            Alessandro Cisselo
                        </h2>
                    </div>
                    <div className="lg:col-span-8">
                        <p
                            className="font-body text-[17px] leading-relaxed"
                            style={{ color: "var(--ns-body)" }}
                        >
                            Law Degree with specialization in International Affairs and Constitutional Law, MBA and advanced specialization in Company Restoration and Corporate Recovery. Over a decade of operational experience in cargo aviation, supply chain disruption management, route restructuring and executive advisory for independent and state-owned operators.
                        </p>
                        <p
                            className="font-body text-[15px] leading-relaxed mt-4"
                            style={{ color: "var(--ns-muted)" }}
                        >
                            For the full scope of services, methodology, core areas of assessment and engagement structure, download the brochure.
                        </p>
                    </div>
                </div>
            </Section>
        </>
    );
};

export default Advisory;
